import { OnSchedResponse } from '../../OnSchedResponse'
import { OnSchedRest }     from '../../OnSchedRest'

export const ServicesElement = element => {
  var el = document.getElementById(element.id);
  el.addEventListener("click", element.onClick);
  
  var url = element.onsched.apiBaseUrl + "/services";
  
  // Limit to 1 result if getFirst option is TRUE
  url = element.options.getFirst ? OnSchedHelpers.AddUrlParam(url, "limit", "1") : url;

  // Add all parameters as query params
  Object.entries(element.params).map(param => {
    url = param[1] ? OnSchedHelpers.AddUrlParam(url, param[0], param[1]) : url;
  })

  OnSchedRest.Get(url, function (response) {
      OnSchedResponse.GetServices(element, response);
  })
}
